"use client";
import { IconLogout } from "@tabler/icons-react";
import { signOut } from "next-auth/react";
import { clearAuthCookies } from "./clear-auth-cookies";
import styles from "./LogoutButton.module.scss";

type LogoutButtonProps = {
  className?: string;
};

const LogoutButton = ({ className }: LogoutButtonProps) => {
  const handleSignOut = async () => {
    clearAuthCookies();
    await signOut({ callbackUrl: "/", redirect: true });
  };

  return (
    <button
      onClick={handleSignOut}
      className={className ? className : styles.logoutButton}
      title="Sign Out"
      type="button"
    >
      <IconLogout size={20} className={styles.icon ?? undefined} />
      <span>Sign Out</span>
    </button>
  );
};

export default LogoutButton;
